<!--
 * @description:填写问诊人信息
 * @fileName: index.vue
 * @author: kxy
 * @date: 2020-01-02 10:28:44
 * @后台人员:汉默
!-->
<template>
  <div id="root">
    <div class="breath" :class="{ big: !showBox }">
      <!-- <van-count-down
        ref="countDown"
        :time="time"
        format="mm:ss"
        :auto-start="false"
        @finish="finish"
      /> -->
      <div class="breath-box">
        <div class="breath-wrap" />
        <div class="spinner-box">
          <img src="../../icons/light.png" alt class="circle-border" />
          <span class="dot" />
        </div>
      </div>

      <span v-show="!showBox" class="tips">系统正在为您派单...</span>
    </div>
    <div v-show="showBox" class="box">
      <p>等待医生问诊</p>
      <p>高峰问诊人数较多，请耐心等待</p>
      <div class="box-bottom">
        <span class="box-bottom-left">
          第
          <span class="special-font mg4">{{ front }}</span>
          位/ 共{{ total }}位
        </span>
        <span class="box-bottom-right" v-if="!customLine">
          预计需
          <span class="special-font mg4">{{ waitingTime }}</span>分钟
        </span>
        <span class="box-bottom-right" v-if="customLine">
          预计需
          <span class="special-font mg4" v-text="countTime + ''"></span>秒
        </span>
      </div>
    </div>
    <div class="info">
      <p>
        <span class="name">{{ info.userName }}</span>
        <span
          class="sex"
          :class="[{ man: info.sex == 1, women: info.sex == 2 }]"
        >{{ info.sex == 1 ? '男' : '女' }}</span>
        <span v-if="age" class="age">{{ age }}</span>
      </p>
      <div class="info-item">
        <span class="item-title">过敏史</span>
        <span class="item-text">{{ info.allergySymptom == 1 ? '无' : (info.allergySymptomExplain || '有') }}</span>
      </div>
      <div class="info-item">
        <span class="item-title">病情描述</span>
        <span class="item-text">{{ info.lastDiagnosis.mainSuit || '无' }}</span>
      </div>
      <div class="info-item">
        <span class="item-title">预购药</span>
        <span v-if="showMedicine&&showPreDrug" class="item-text">
          <span
            v-for="title in medicineArr"
            :key="title.id"
          >{{ title.commonName || title.productName }}</span>
        </span>
        <span v-if="medicineArr.length===0 || !showPreDrug" class="item-title">
          <span class="black-font">无</span>
        </span>
      </div>
    </div>
    <div class="cancel" @click="cancelConfirm">取消问诊</div>
    <LoadingComponent :is-show="isShowLoading" />
  </div>
</template>
<script>
import { Dialog } from 'vant'
import LoadingComponent from '@/components/Loading'
import {
  getWaitingDetail,
  goInquiry,
  savePatient,
  realTimeSearchPatient,
  checkOrganSignSwitch
} from '../../api/index'
import { cancelInquiry,getAutoInquiryInfo,onEnterRoom,autoVideoInquiryDispatch,closePrescriptionForAutoVideoInquiry } from '../../api/video'
import { getCookie } from '../../utils/auth'
import { versionFunegt, getIsIos, getIsAndroid } from '../../utils/index'
import { initLog } from '@/utils/'
window._version = '1.3'
export default {
  components: {
    LoadingComponent
  },
  data() {
    return {
      showPreDrug:false, // 显示预购药品
      isShowLoading: false,
      time: 0,
      versionCode: '',
      showBox: true,
      info: {},
      front: 0,
      total: 0,
      waitingTime: 0,
      countTime:0,
      organSign: '',
      roomNumber: '',
      patientGuid: '',
      employeeId: '',
      userSign: '',
      ids: {},
      inquiryReportGuid:'',
      isPolling: true, // 是否进行轮询
      pollingTimer: null,
      waitInfoIsInit: false, // 等待信息是否已初始化
      isDispatching: false, // 是否派单中
      isAutoInquiry:0, // 是否ai问诊
      isEnterRoom:false, // 是否ai问诊
      cancelFlag:false, // 是否取消
      customLine:false, // 是否自定义
      age: '' // 年龄
    }
  },
  created() {
      this.checkOrganSignSwitch()
    this.info = JSON.parse(localStorage.getItem('params'))
        this.getCookies()
    this.ids = JSON.parse(this.$route.query.ids)
    this.inquiryReportGuid = this.$route.query.inquiryReportGuid
    this.employeeId = this.ids.employeeId
    this.userSign = this.ids.userSign
    // 修改顶部状态栏颜色
    this.setChangeStatusBar('#242424')
    // 轮询获取等待人数等最新数据
    this.getAutoInquiryInfo()
    this.fetchAge()
    this.setLog({
      message: '进入视频问诊轮询页面',
      type: '/prescription'
    })
    window.streamRemoved = this.streamRemoved;
    window.localityRemoved = this.localityRemoved;
    window.joinRoomCountDownFn = this.joinRoomCountDownFn;
  },
  beforeDestroy() {
    this.stopPolling()
    this.setChangeStatusBar('#ffffff')
    clearInterval(this.timer);
  },
  computed:{
    showMedicine(){
      if(this.info&&this.info.lastDiagnosis){
        if((this.info.lastDiagnosis.prescriptionDetail&&this.info.lastDiagnosis.prescriptionDetail.length > 0) ||(this.info.lastDiagnosis.prescriptionTCMDetail&&this.info.lastDiagnosis.prescriptionTCMDetail.length > 0)){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
      
    },
    medicineArr(){
      if(this.info.medicineType==0){
        return this.info.lastDiagnosis.prescriptionDetail
      }else{
        return this.info.lastDiagnosis.prescriptionTCMDetail
      }
    }
  },
  methods: {
      async checkOrganSignSwitch(){
            try {
                let res = await checkOrganSignSwitch({ organSign: getCookie('native_organSign') })
                console.log(res,"---tjy")
                if(res.data.code == 0) {
                 this.showPreDrug = !(res.data.result && res.data.success)
                }
            } catch (error) {
            }
      },
    /**
     * // TO
     * andriod 版本为 > 1.2.1
     * ios >= 1.3.0 时
     * @msg: 设置导航栏颜色
     * @param {colorVal}
     */
    setChangeStatusBar(colorVal) {
      const curAndroidVersion = '1.2.2'
      const curIosVersion = '1.3.0'
      if (getIsIos()) {
        if (this.getVersonFlag(curIosVersion)) {
          this.setBarColorBrBridge(colorVal)
        }
      } else if (getIsAndroid()) {
        if (this.getVersonFlag(curAndroidVersion)) {
          this.setBarColorBrBridge(colorVal)
        }
      }
    },
    /**
     * @msg: 设置导航栏颜色通讯协议
     * @param {type}
     */
    setBarColorBrBridge(colorVal) {
      window.location.href = `protocol://action/statusBarColor?hex=${colorVal}`
    },
    /**
     * @msg: 获取平台版本
     * @param {type}
     * @return: true or false
     */
    getVersonFlag(arg) {
      const version = getCookie('native_version')
      return versionFunegt(version, arg)
    },
    async fetchAge() {
      const res = await realTimeSearchPatient({
        guid: this.info.patientGuid,
        organSign: this.$route.query.organSign || getCookie('native_organSign')
      })
      if (res.data.result.list.length > 0) {
        this.age = res.data.result.list[0].age
      }
    },
    stopPolling() {
      this.isPolling = false
      if (this.pollingTimer != null) {
        clearTimeout(this.pollingTimer)
      }
      console.warn('停止轮询++++++++++++++++++++++')
    },
    getCookies() {
      const client = getCookie('native_client')
      if (client === 'android' || client === 'ios' || client === 'pad') {
        this.organSign = getCookie('native_organSign')
      } else {
        this.organSign = getCookie('organSign')
      }
    },
    cancelConfirm() {
      Dialog.confirm({
        title: '提示',
        message: '系统正在为您派单，确定要退出吗？',
      })
        .then(() => {
          this.cancel();
        })
        .catch(() => {
          console.log("no")
        });
    },
    cancel() {
      this.cancelFlag = true;
      this.isShowLoading = true
      console.log(`点击取消问诊,roomNumber:${this.info.roomNumber}`)
      this.setLog({
        message: `点击取消问诊,roomNumber:${this.info.roomNumber}`,
        type: '/prescription'
      })
      cancelInquiry({
        roomNumber: this.info.roomNumber,
        inquiryRecordGuid: this.$store.getters.inquiryRecordGuid,
        patientGuid: this.info.patientGuid
      })
        .then(res => {
          this.isShowLoading = false
          console.log(`取消问诊接口成功,roomNumber:${this.info.roomNumber}`);
          this.setLog({
            message: `取消问诊接口成功,roomNumber:${this.info.roomNumber}`,
            type: '/prescription'
          })
          this.stopPolling()
          console.log('视频取消接口调用成功', res)
          this.$router.replace('/interrogationInfoText')
          this.$router.go(-1)
        })
        .catch(err => {
          this.isShowLoading = false
          this.setLog({
            message: '取消问诊接口失败',
            type: '/prescription'
          })
          console.error('视频取消接口调用失败', err)
        })
    },
    // start() {
    //   this.time = 100000
    //   this.$nextTick(() => {
    //     this.$refs.countDown.reset()
    //     this.$refs.countDown.start()
    //   })
    // },
    startNextWaitInfoRequest() {
      console.log('进入startNextWaitInfoRequest')
      getWaitingDetail({
        organSign: this.organSign,
        patientGuid: this.info.patientGuid,
        roomNumber: this.info.roomNumber
      })
        .then(res => {
          console.log('240' + '测试进入')
          // 初始化时，启动定时器
          if (!this.waitInfoIsInit) {
            this.waitInfoIsInit = true
            this.isDispatching = res.data.result.lineUpRanking === 0
            // 如果在派单中
            if (this.isDispatching) {
              this.time = 30 * 1000
            } else {
              this.time = res.data.result.waitingTime * 60 * 1000
            }
            // this.$nextTick(() => {
            //   this.$refs.countDown.start()
            // })
          } else {
            const currentIsDispatching = res.data.result.lineUpRanking === 0

            // 如果最新状态在派单中，且之前不在派单中
            if (currentIsDispatching && !this.isDispatching) {
              this.time = 30 * 1000
              // this.$nextTick(() => {
              //   this.$refs.countDown.reset()
              //   this.$refs.countDown.start()
              // })
            }
            this.isDispatching = currentIsDispatching
          }
          this.front = res.data.result.lineUpRanking
          this.total = res.data.result.await
          // 处理等待卡片是否显示
          this.waitingTime = res.data.result.waitingTime
          if (res.data.result.lineUpRanking === 0) {
            this.showBox = false
          }
          if (res.data.result.isPhysicianConnecting === 1) {
            // 停止轮询
            console.warn('isPhysicianConnecting === 1')
            this.stopPolling()
            // 发起视频验证
            this.goInquiry()
          } else if (res.data.result.isPhysicianConnecting === 6) {
            // 轮询返回取消问诊
            console.log('测试状态isPhysicianConnecting6')
            this.setLog({
              message: '轮询返回取消问诊',
              type: '/prescription'
            })
            cancelInquiry({
              roomNumber: this.info.roomNumber,
              inquiryRecordGuid: this.$store.getters.inquiryRecordGuid,
              patientGuid: this.info.patientGuid
            })
              .then(res => {
                this.setLog({
                  message: '轮询返回取消问诊成功',
                  type: '/prescription'
                })
                this.$toast({ message: '视频连接失败,请重新发起问诊' })
                setTimeout(() => {
                  this.$router.replace('/interrogationInfoText')
                  this.$router.go(-1)
                }, 1000)
              })
              .catch(err => {
                this.setLog({
                  message: '轮询返回取消问诊失败',
                  type: '/prescription'
                })
                console.error('视频取消接口调用失败', err)
              })
          }
        })
        .catch(err => {
          this.setLog({
            message: '视频问诊轮询页面，catch ' + err,
            type: '/prescription'
          })
        })
        .finally(() => {
          console.log('进入finally')
          console.log("this.ispolling", this.isPolling);
          if (this.isPolling) {
            const that = this
            this.pollingTimer = setTimeout(() => {
              that.startNextWaitInfoRequest()
            }, 3000)
          }
        })
    },
    // finish() {
    //   console.log('倒计时结束')
    //   // 重启倒计时
    //   this.$nextTick(() => {
    //     this.$refs.countDown.reset()
    //     this.$refs.countDown.start()
    //   })
    // },
    // 去问诊,调视频
    goInquiry() {
      window.location.href = `protocol://action/app_trtc?userid=${this.employeeId}&usersig=${this.userSign}&roomid=${this.info.roomNumber}&pageType=1`
      this.setLog({
        message: '去问诊，调视频sdk',
        type: '/prescription'
      })
    },
    /**
     * @description: 加log日志
     * @param {Object} json对象
     * @return:
     */
     setLog(msg) {
      $hyjkLoggerSdk.info(initLog(msg), "PATIENTH5");
    },

    setVideoTime() {
      const _this = this;
      _this.timer = setInterval(() => {
        this.countTime--;
        if (this.countTime == 0) {
          this.showBox = false;
          if (!this.cancelFlag) {
            this.goInquiry()
          }
          this.cancelFlag = false;
          clearInterval(_this.timer);
        }
      }, 1000);
    },

    async getAutoInquiryInfo() {
      
      let res = await getAutoInquiryInfo({organSign:this.organSign,inquiryGuid:this.inquiryReportGuid});
        if (res.data.code == 0) {
          this.isAutoInquiry = res.data.result.isAutoInquiry;
        if (this.isAutoInquiry == 1) {
        // 计算问诊倒计时时间
        this.customLine = true;
        this.front = 1; // 当前排队数
        this.total = 1; // 总排队人数
        this.countTime = res.data.result.waitSecond; // 排队时间
        this.setVideoTime();
        }else {
        // 轮询获取等待人数等最新数据
        this.startNextWaitInfoRequest();
        }
        }else {
          this.$toast({
          message:res.data.msg
        })
        }
        
    },
    async joinRoomCountDownFn() {
     if (this.isAutoInquiry == 1) {
      await onEnterRoom({organSign:this.organSign,inquiryGuid:this.inquiryReportGuid});
      this.isEnterRoom = true;
      if (res.data.code != 0) {
        this.$toast({
          message:res.data.msg
        })
      }

     }
    },
    async streamRemoved() {
      if (this.isAutoInquiry == 1) {
        await autoVideoInquiryDispatch({organSign:this.organSign,inquiryGuid:this.inquiryReportGuid});
        if (res.data.code != 0) {
        this.$toast({
          message:res.data.msg
        })
      }
      this.isEnterRoom = false;
      this.isAutoInquiry = 0;
      }
    },
    async localityRemoved() {
      if (this.isAutoInquiry == 1 && this.isEnterRoom) {
        await closePrescriptionForAutoVideoInquiry({inquiryGuid:this.inquiryReportGuid});
        if (res.data.code != 0) {
        this.$toast({
          message:res.data.msg
        })
        }
      this.isEnterRoom = false;
      this.isAutoInquiry = 0;
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../common/font.css';

@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes breath {
  0% {
    background: rgba(252, 145, 84, 0.4);
    width: 75px;
    height: 75px;
  }
  33% {
    background: rgba(252, 145, 84, 0.12);
    width: 180px;
    height: 180px;
  }
  66% {
    background: rgba(227, 176, 147, 0.05);
    width: 200px;
    height: 200px;
  }
}
* {
  box-sizing: border-box;
}
#root {
  background: rgba(36, 36, 36, 1);
  min-height: 100vh;
  padding: 0 20px 10px 20px;
  height: calc(100% - 10px);
}
.breath {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .tips {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(252, 145, 84, 1);
    line-height: 28px;
    position: absolute;
    bottom: 40px;
  }
  .van-count-down {
    position: absolute;
    top: calc(50% - 16px);
    left: calc(50% - 35px);
    z-index: 999;
    width: 70px;
    height: 32px;
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: rgba(252, 145, 84, 1);
    line-height: 32px;
  }
}
.breath-wrap {
  animation: breath 2s linear 0s infinite;
  border-radius: 50%;
}
.spinner-box {
  position: absolute;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  background-color: transparent;
  width: 100px;
  height: 100px;
  animation: spin 2s linear 0s infinite;
}
/* SPINNING CIRCLE */
.circle-border {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.dot {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgb(254, 155, 95);
  position: absolute;
  top: -4px;
  left: calc(50% - 5px);
  z-index: 9999;
}
.circle-core {
  width: 100%;
  height: 100%;
  background-color: rgb(172, 116, 85);
  border-radius: 50%;
}
.big {
  height: 370px;
}
.box {
  width: 100%;
  height: 131px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 15px 20px 0 20px;
  p {
    margin: 0;
    padding: 0;
  }
  p:nth-child(1) {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    margin-bottom: 4px;
  }
  &:nth-child(2) {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }
  .box-bottom {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    .special-font {
      font-family: 'Roboto';
      font-size: 28px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .mg4 {
      margin: 0 4px;
    }
    .box-bottom-left {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .box-bottom-right {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
}
.info {
  width: 100%;
  min-height: 200px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin-top: 20px;
  padding: 25px 20px 10px 20px;
  p {
    margin: 0;
    padding: 0;
  }
  p:nth-child(1) {
    display: flex;
    align-items: center;
    .name {
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 30px;
    }
    margin-bottom: 20px;
    .sex {
      display: block;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      width: 24px;
      height: 24px;
      border-radius: 30px;
      text-align: center;
      line-height: 24px;
      margin: 0 10px;
    }
    .man {
      background: rgba(107, 167, 255, 1);
    }
    .women {
      background: #ff6e6e;
    }
    .age {
      // width: 46px;
      padding: 0 10px;
      height: 24px;
      background: rgba(255, 255, 255, 1);
      border-radius: 12px;
      border: 1px solid rgba(231, 231, 231, 1);
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(136, 136, 136, 1);
      line-height: 24px;
      text-align: center;
      white-space: nowrap;
    }
  }
  .info-item {
    width: 100%;
    display: flex;
    margin-bottom: 17px;
    .item-title {
      display: inline-block;
      width: 48px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(187, 187, 187, 1);
      line-height: 22px;
      margin-right: 20px;
      white-space: nowrap;
    }
    .item-text {
      width: calc(100% - 68px);
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      line-height: 22px;
      white-space: pre-wrap;
      display: block;
      span {
        &:not(:last-child):after {
          content: '、';
        }
      }
    }
  }
}
.black-font {
  color: #444444;
}
.cancel {
  height: 50px;
  background: rgba(239, 77, 77, 1);
  border-radius: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  margin-top: 20px;
  text-align: center;
}
.visi {
  visibility: hidden;
}
</style>
